import KeplerSdk from './../../keplerSdk.js'

const state = {
    clientTypes: [],
    clientTypesLastFetch: null,
}

const mutations = {
    SET_CLIENT_TYPES_LIST (state, message) {
        state.clientTypes = message
    },
    SET_CLIENT_TYPES_LAST_FETCH (state, message) {
        state.clientTypesLastFetch = message
    },
}

const actions = {
    fetchClientTypes: ({commit}, payload) => {
        if (state.clientTypesLastFetch == null) {
            KeplerSdk.getClientTypes(function (data) {
                commit('SET_CLIENT_TYPES_LAST_FETCH', Math.floor(Date.now() / 1000))
                commit('SET_CLIENT_TYPES_LIST', data)
            })
        }
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/frontoffice/clientTypesStore.js